import {Inject, Injectable, InjectionToken} from '@angular/core';
import {IConfig} from '../models/IConfiguration';

export let APP_CONFIG_TOKEN = new InjectionToken('app.config');


@Injectable()
export class AppConfigService {
  constructor(
    @Inject(APP_CONFIG_TOKEN) private conf: IConfig | null
  ) {

  }

  get config(): IConfig {
    return this.conf;
  }
}
